export default {
    data() {
        return {
            time_show: false,
            timeColumns: [
                "08:00",
                "08:30",
                "09:00",
                "09:30",
                "10:00",
                "10:30",
                "11:00",
                "12:30",
                "13:00",
                "13:30",
                "14:00",
                "14:30",
                "15:00",
                "15:30",
                "16:00",
                "16:30"
            ]
        }
    },
    methods: {
        onTimeChange(value) {
            this.reTime = value;
            this.time_value = value;
            this.time_show = false;
        }
    },
}